import { Link, LinkProps, Text } from "@chakra-ui/react";

import { LinearIssueStatusIcon } from "@/feature/components/LinearIssueStatusIcon";
import { LinearCleanupIssueDetails } from "@reflag/shared/featureAPI";

export function LinearCleanupIssueLink({
  url,
  issue,
  ...rest
}: {
  url: string;
  issue: LinearCleanupIssueDetails | null;
} & Omit<LinkProps, "href">) {
  const identifier =
    issue?.identifier ??
    url.match(/\/issue\/([A-Za-z0-9]+-\d+)(?:\/|[?#]|$)/)?.[1];
  const status = issue?.state?.name ?? "Status unavailable";
  return (
    <Link
      alignItems="center"
      display="inline-flex"
      gap={1}
      href={url}
      whiteSpace="nowrap"
      textDecoration="none"
      variant="unstyled"
      rel="noopener noreferrer"
      aria-label={`${identifier ?? "Linear issue"}: ${status}`}
      isExternal
      {...rest}
    >
      <LinearIssueStatusIcon state={issue?.state ?? null} />
      <Text as="span" fontWeight="normal">
        {identifier ?? "Linear issue"}
      </Text>
    </Link>
  );
}
